import { userService } from '../services/user'
import router from '../router/index'

const user = JSON.parse(localStorage.getItem('user'))
const initialState = user
  ? { status: { signedIn: true }, user }
  : { status: {}, user: null }

export const authentication = {
  namespaced: true,
  state: initialState,
  actions: {
    login ({ dispatch, commit }, { email, password }) {
      commit('loginRequest', { email })

      userService.login(email, password)
        .then(
          user => {
            commit('loginSuccess', user)
            router.push('/')
          },
          error => {
            commit('loginFailure', error)
          }
        )
    },
    logout ({ commit }) {
      userService.logout()
      commit('logout')
    }
  },
  mutations: {
    loginRequest (state, user) {
      state.status = { signingIn: true }
      state.user = user
    },
    loginSuccess (state, user) {
      state.status = { signedIn: true }
      state.user = user
    },
    loginFailure (state, error) {
      state.status = {}
      state.status.error = error
      state.user = null
    },
    logout (state) {
      state.status = {}
      state.user = null
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/authentication.js